import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { DefaultOptionType } from 'antd/es/select'
import { Check, GripVertical } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

type SortableOptionProps = {
  option: DefaultOptionType
  isSelected: boolean
  onSelect: (value: DefaultOptionType['value']) => void
}

export const SortableOption = ({ option, isSelected, onSelect }: SortableOptionProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: String(option.value),
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      onMouseDown={(event) => {
        event.preventDefault()
        if (!option.disabled) onSelect(option.value)
      }}
      className={cn(
        'flex cursor-pointer items-center gap-1.5 rounded px-2 py-1.5 text-body-default',
        'hover:bg-main-background-interactive-list-hover',
        isSelected &&
          '!bg-main-background-interactive-list-selected !font-medium !text-main-foreground-accent hover:!bg-main-background-interactive-list-selectedHover',
        option.disabled && 'cursor-not-allowed opacity-50',
        isDragging && 'opacity-50',
      )}
    >
      <span
        {...attributes}
        {...listeners}
        onMouseDown={(event) => event.stopPropagation()}
        className='flex cursor-grab items-center text-main-foreground-tertiary'
      >
        <GripVertical className='size-4 shrink-0' />
      </span>
      <span className='flex-1 truncate'>{option.label as React.ReactNode}</span>
      {isSelected && <Check className='size-4 shrink-0 text-main-foreground-accent' />}
    </div>
  )
}
